import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";

import { ExpandedTable, IButton, Layout, ITooltip, StoredPagination, ConfirmModal, SearchFormField } from "../../ui-kit";
import RouteForm from "./forms/route";

import routesStore from "../../store/routesSettings";
import userStore from "../../store/users";

import styles from "./styles.module.scss";
import { TrashIco } from "../../assets/customIcons";
import Paths from "../../constants/PathsBreadcrumbs";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";
import { useStatusMessage } from "../../hooks/useStatusMessage";
import Constants from "../../constants/Common";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";
import { useHandleForm } from "../../hooks/useHandleForm";
import { useSearch } from "../../hooks/useSearch";

const RouteSettings: FC = observer(() => {
  useBreadcrumbs(Paths.adminSystemSettings);

  const {
    titleIcons: { trash },
  } = Constants;
  const {
    routesData,
    getRoutesList,
    routesIsLoading,
    isShowAddForm,
    deleteRoute,
    routeStatus,
    paginator,
    sorter,
    filter,
    search,
  } = routesStore;

  const { getRolesList, roles, getUsersList, usersData } = userStore;

  useEffect(() => {
    getRoutesList();
  }, [
    filter.filterItems,
    paginator.page,
    paginator.perPage,
    sorter.changingKey,
    search.search.text,
  ]);

  useEffect(() => {
    getRolesList();
    getUsersList();
  }, []);

  useStatusMessage(routeStatus);

  const {
    confirmModalData,
    toggleConfirmModal,
    closeConfirmModal,
    confirmDelete,
  } = useDeleteConfirm(deleteRoute);
   
  const searchForm = useHandleForm(null, { text: "" }, { text: false });
  const {
    handleOnClear: handleClearSearch,
    handleOnChange: handleChangeSearch,
    onFindClick,
  } = useSearch({
    search: search,
    delay: 1000,
    searchForm: searchForm,
    searchKey: "text",
    onFindAction: getRoutesList,
  });

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      render: (text, record, index) =>
        text && text.length > 0 ? text : record.entityName,
    },
    // {
    //   title: "Сущность",
    //   dataIndex: "entityName",
    //   key: "entityName",
    // },
    {
      title: "",
      key: "delete",
      render: (text, record, index) => (
        <ITooltip title={trash} placement="right">
          <TrashIco
            onClick={(e) => {
              e.stopPropagation();
              toggleConfirmModal({ show: true, id: record.id });
            }}
          />
        </ITooltip>
      ),
      className: "delete-cell",
    },
  ];

  return (
    <Layout type="white">
      <div className={styles.Filter}>
        <div className={styles.controls}>
        <SearchFormField
            name="searchText"
            label="Поиск маршрута по названию"
            type="text"
            className={styles.UsersSearch}
            value={searchForm.watchAllField.text}
            isFocused={searchForm.isFocused.text}
            onFocus={searchForm.handleFocus}
            onBlur={searchForm.handleBlur}
            onClear={handleClearSearch}
            onChange={handleChangeSearch}
            onFindClick={onFindClick}
          />
        </div>
      </div>      
      <ExpandedTable
        loading={routesIsLoading.value}
        columns={columns}
        data={routesData}
      >
        <RouteForm />
      </ExpandedTable>
      <StoredPagination {...paginator} />
      {isShowAddForm.value && <RouteForm />}
      <ConfirmModal
        message={'При удалении будет очищена вся история согласований по этому маршруту. Вы действительно хотите удалить маршрут?'}
        visible={confirmModalData.show}
        onClose={closeConfirmModal}
        onConfirm={confirmDelete}
      />      
    </Layout>
  );
});

export default RouteSettings;
